import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "app-tool-tip",
  template: `
    <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="text" [tooltipPosition]="position" [escape]="escape" [tooltipStyleClass]="tooltipStyleClass"></app-icon>
  `,
  styleUrls: ["./tool-tip.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolTipComponent {
  @Input() text = "";
  @Input() position = "top";
  // Defaults to true so HTML stays escaped everywhere; set to false to render HTML markup.
  @Input() escape = true;
  // Optional class applied to the tooltip container (e.g. to widen it for HTML content).
  @Input() tooltipStyleClass = "";
}
